import { components } from '../../tokens/components/diamond/TR';
import { createTheme } from '../../tokens/createTheme';
import alertTokens from '../cobalt/components/alert.tokens';
import createCalendarTokens from '../cobalt/components/calendar.tokens';
import checkboxTokens from '../cobalt/components/checkbox.tokens';
import drawerHeaderTokens from '../cobalt/components/drawerHeader.tokens';
import inputTokens from '../cobalt/components/input.tokens';
import sliderTokens from '../cobalt/components/slider.tokens';
import type { DeprecatedTheme } from '../types';
import colors from './colors/TR';
import { ED } from './ED';

const { borders, space, fontSizes, sizes, lineHeights } = ED;

const fontSizeBody = fontSizes.body;

const drawerHeader = drawerHeaderTokens({
  colors,
  borders,
  space,
});

const slider = sliderTokens({
  colors,
  sizes,
  space,
  fontSizeBody,
});

const checkbox = checkboxTokens({
  borders,
  colors,
  space,
  lineHeights,
  fontSizeBody,
  sizes,
});

const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const DIAMOND_TR: DeprecatedTheme = createTheme(
  'diamond',
  {
    ...ED,
    colors: {
      ...colors,
      text: colors,
      drawerHeader: drawerHeader.colors,
      slider: slider.colors,
      checkbox: checkbox.colors,
      brandedProgressBar: colors.primary['30'],
      input: input.colors,
      alert: alert.colors,
      brandedHeaderBg: colors.primary['50'],
      calendar: calendar.colors,
    },
    borders: {
      ...borders,
      alert: alert.borders,
    },
  },
  components
);

export default DIAMOND_TR;
